import groupBy from 'lodash.groupby';

import type { ContactQuerySchema } from '../schemas';

export function contactAgreementsHelper(
  agreements: ContactQuerySchema['agreements']
): ContactQuerySchema['agreements'] {
  const groupedAgreements = groupBy(agreements ?? [], 'parent_id');
  const agreementsWithAddendums = (groupedAgreements?.['null'] ?? []).map((t) => {
    const addendumsArr = groupedAgreements[`${t.id}`];
    const uniqueAddendums = Array.from(new Map((addendumsArr ?? []).map((item) => [item.id, item])).values());

    return {
      ...t,
      addendums: uniqueAddendums ?? null,
    };
  });

  // Collect child agreements but exclude those whose parent already exists among root agreementsWithAddendums
  const parentIds = new Set(agreementsWithAddendums.map((a) => a.id));
  const childAgreements = Object.entries(groupedAgreements)
    .filter(([parentId]) => parentId !== 'null')
    .flatMap(([, arr]) => arr ?? [])
    .filter((f) => f?.parent_id !== null && !parentIds.has(f.parent_id));

  return [...agreementsWithAddendums, ...childAgreements];
}
